import { render, staticRenderFns } from "./EPromoterNoData.vue?vue&type=template&id=5dada1e8&scoped=true&"
import script from "./EPromoterNoData.vue?vue&type=script&lang=js&"
export * from "./EPromoterNoData.vue?vue&type=script&lang=js&"
import style0 from "./EPromoterNoData.vue?vue&type=style&index=0&id=5dada1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dada1e8",
  null
  
)

export default component.exports